import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Brain, Clock, Heart } from './Icons';
export function PainSection() {
  return <section className="py-10 md:py-20 px-4 bg-white relative" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        {/* THE HOOK */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-20" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6 leading-tight" data-id="element-110">
            ¿Sientes que estás compitiendo contra un algoritmo de mil millones
            de dólares por la atención de tu propio hijo?
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto mb-8 rounded-full" data-id="element-111"></div>
          <p className="text-xl text-warm-dark leading-relaxed mb-6" data-id="element-112">
            <span className="font-bold bg-amber-light px-2 py-1 rounded" data-id="element-113">
              No eres tú. Es la neuroquímica.
            </span>
          </p>
          <p className="text-lg text-warm-medium leading-relaxed max-w-3xl mx-auto" data-id="element-114">
            Pero mientras tú intentas ser una buena madre, Silicon Valley está
            diseñando la próxima aplicación para que tu hijo no pueda despegar
            la vista del cristal.{' '}
            <strong className="text-navy" data-id="element-115">
              Hoy, esa batalla termina aquí.
            </strong>
          </p>
        </motion.div>

        {/* PAIN AGITATION */}
        <div className="bg-cream-dark rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-inner relative overflow-hidden" data-id="element-116">
          <div className="absolute top-0 right-0 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-117"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-118">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-5 md:mb-8 text-center" data-id="element-119">
              Mira a tu hijo ahora mismo...
            </h3>

            <div className="space-y-4 md:space-y-6 mb-6 md:mb-10" data-id="element-120">
              <div className="flex gap-4 items-start" data-id="element-121">
                <div className="bg-white p-3 rounded-full shadow-sm mt-1" data-id="element-122">
                  <Clock className="w-6 h-6 text-terracotta" data-id="element-123" />
                </div>
                <p className="text-lg text-warm-dark pt-2" data-id="element-124">
                  ¿Cuándo fue la última vez que lo viste jugar con un simple
                  cartón durante una hora?
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-125">
                <div className="bg-white p-3 rounded-full shadow-sm mt-1" data-id="element-126">
                  <Heart className="w-6 h-6 text-terracotta" data-id="element-127" />
                </div>
                <p className="text-lg text-warm-dark pt-2" data-id="element-128">
                  ¿O que te miró a los ojos sin que hubiera una pantalla de por
                  medio?
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-129">
                <div className="bg-white p-3 rounded-full shadow-sm mt-1" data-id="element-130">
                  <Smartphone className="w-6 h-6 text-terracotta" data-id="element-131" />
                </div>
                <p className="text-lg text-warm-dark pt-2" data-id="element-132">
                  Esa irritabilidad cuando le quitas el iPad... ese vacío en su
                  mirada cuando se aburre... esa falta de paciencia...
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-l-4 border-terracotta shadow-md" data-id="element-133">
              <p className="text-xl font-bold text-navy mb-4" data-id="element-134">
                No es mala educación. Es un cerebro sobre-estimulado.
              </p>
              <p className="text-lg text-warm-medium mb-4" data-id="element-135">
                Te sientes agotada. Culpable. Sientes que el iPad es tu "niñera
                de emergencia" porque no tienes más energía.{' '}
                <strong data-id="element-136">Te entiendo. Yo estuve ahí.</strong>
              </p>
              <p className="text-lg text-terracotta-dark font-bold" data-id="element-137">
                Pero ignorar esto hoy es hipotecar la salud mental de tu hijo
                mañana.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}